module.exports = __webpack_public_path__ + "static/media/r35.b64b670d.jpg";